<template>
  <div class="container-fluid px-0 login-page-container">
    <h1 class="width--100per t-600 t-lr text-center bg-blue t-white d-block d-md-none">AcademicLabs</h1>

    <div class="row min-height--100vh mx-0">
      <!-- right text -->
      <right-text :isRegister="true" :showExploreCTA="false" />

      <div class="col-md-8 col-sm-12 bg-grey">
        <div class="row align-items-center text-md-left">
          <!-- render template -->
          <register />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RightText from '@/components/login/RightSideText'
import Register from '@/views/signup/Register'

export default {
  name: 'signUp',
  components: {
    RightText,
    Register
  }
}
</script>
